module.exports = __webpack_public_path__ + "img/vpn-meaning.f19cdabf.webp";